<nav class="breadcrumb-container" aria-label="Percorso di navigazione">
  <ol class="breadcrumb">
    <li *ngFor="let item of breadcrumbs" class="breadcrumb-item" [ngClass]="{'active': item.active}">
      <a [href]="item.link">{{item.label}}</a>
      <span *ngIf="!item.active" class="separator" aria-hidden="true">/</span>
    </li>
  </ol>
</nav>
